(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doma-box-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('doma-box-builder')) {
    class DomaBoxBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.cards = [...this.querySelectorAll('[data-box-product]')];
        this.items = this.cards.filter(card => card.querySelector('[data-box-quantity]')).map(card => ({
          card, id: Number(card.dataset.variantId), productId: Number(card.dataset.productId),
          title: card.dataset.title, price: Number(card.dataset.price), stock: Number(card.dataset.stock), quantity: 0,
          input: card.querySelector('[data-box-quantity]'), minus: card.querySelector('[data-box-minus]'), plus: card.querySelector('[data-box-plus]')
        }));
        this.productIds = new Set(this.cards.map(card => Number(card.dataset.productId)));
        this.cartItems = [];
        this.existing = 0;
        this.busy = false;
        this.loaded = false;
        this.pendingKey = 'doma-box-pending';
        this.completed = false;
        try { this.uncertain = Boolean(localStorage.getItem(this.pendingKey)); } catch { this.uncertain = false; }
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
        this.add = this.querySelector('[data-box-add]');
        this.reset = this.querySelector('[data-box-reset]');
        this.status = this.querySelector('[data-box-status]');
        this.retry = this.querySelector('[data-box-retry]');
        this.items.forEach(item => {
          item.card.querySelector('[data-box-controls]').hidden = false;
          item.minus.addEventListener('click', () => this.setQuantity(item, item.quantity - 1));
          item.plus.addEventListener('click', () => this.setQuantity(item, item.quantity + 1));
          item.input.addEventListener('change', () => this.setQuantity(item, Number(item.input.value)));
        });
        this.reset.addEventListener('click', () => { if (this.busy || this.uncertain || this.completed) return; this.items.forEach(item => item.quantity = 0); this.render(); });
        this.retry.addEventListener('click', () => this.refreshCart());
        this.querySelector('[data-box-mobile]').hidden = false;
        this.querySelector('.doma-box__cart').addEventListener('click', () => {
          try { localStorage.removeItem(this.pendingKey); } catch {}
          this.uncertain = false;
          this.completed = true;
        });
        this.add.addEventListener('click', () => this.addSelection());
        this.onPageShow = event => {
          if (!event.persisted || !this.isConnected) return;
          if (this.completed) { this.items.forEach(item => item.quantity = 0); this.completed = false; }
          this.refreshCart();
        };
        window.addEventListener('pageshow', this.onPageShow);
        if (this.uncertain) { this.status.textContent = this.dataset.addError; this.render(); } else this.refreshCart();
      }
      disconnectedCallback() { window.removeEventListener('pageshow', this.onPageShow); }
      total() { return this.items.reduce((sum, item) => sum + item.quantity, 0); }
      inCart(item) { return this.cartItems.filter(line => Number(line.variant_id) === item.id).reduce((sum, line) => sum + line.quantity, 0); }
      limit(item) { return Math.max(0, Math.min(6 - this.existing - this.total() + item.quantity, item.stock - this.inCart(item))); }
      setQuantity(item, value) {
        if (this.busy || !this.loaded || this.uncertain || this.completed) return;
        item.quantity = Math.max(0, Math.min(this.limit(item), Number.isFinite(value) ? Math.floor(value) : 0));
        this.render();
      }
      async readCart() {
        const response = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('cart');
        this.cartItems = cart.items;
        this.existing = cart.items.filter(line => this.productIds.has(Number(line.product_id))).reduce((sum, line) => sum + line.quantity, 0);
        this.loaded = true;
      }
      async refreshCart() {
        if (this.busy || this.uncertain || this.completed) return;
        this.busy = true;
        this.status.textContent = this.dataset.loading;
        this.retry.hidden = true;
        this.render();
        try { await this.readCart(); this.status.textContent = ''; }
        catch { this.loaded = false; this.status.textContent = this.dataset.readError; this.retry.hidden = false; }
        finally { this.busy = false; this.render(); }
      }
      render() {
        const count = this.total();
        const combined = count + this.existing;
        const invalid = combined > 6 || this.items.some(item => item.quantity > Math.max(0, item.stock - this.inCart(item)));
        this.items.forEach(item => {
          item.input.value = item.quantity;
          item.input.max = this.limit(item);
          item.input.disabled = this.busy || !this.loaded || this.uncertain || this.completed;
          item.minus.disabled = this.busy || !this.loaded || this.uncertain || this.completed || item.quantity === 0;
          item.plus.disabled = this.busy || !this.loaded || this.uncertain || this.completed || item.quantity >= this.limit(item);
        });
        this.querySelector('[data-box-count]').textContent = this.dataset.count.replace('[count]', combined);
        this.querySelector('[data-box-mobile-count]').textContent = this.dataset.count.replace('[count]', combined);
        this.querySelectorAll('[data-box-slot]').forEach((slot, index) => { slot.classList.toggle('is-filled', index < combined); slot.classList.toggle('is-existing', index < this.existing); });
        const existing = this.querySelector('[data-box-existing]');
        existing.hidden = this.existing === 0;
        existing.textContent = this.dataset.existing.replace('[count]', this.existing);
        this.querySelector('[data-box-space]').textContent = invalid ? this.dataset.over : this.existing >= 6 ? this.dataset.full : combined === 6 ? this.dataset.ready : combined === 0 ? this.dataset.empty : this.dataset.space.replace('[count]', 6 - combined);
        const list = this.querySelector('[data-box-selection]');
        list.replaceChildren(...this.items.filter(item => item.quantity).map(item => {
          const line = document.createElement('li');
          const label = document.createElement('span');
          const price = document.createElement('span');
          label.textContent = item.quantity + ' × ' + item.title;
          price.textContent = this.money.format(item.price * item.quantity / 100);
          line.append(label, price);
          return line;
        }));
        this.querySelector('[data-box-subtotal]').textContent = this.money.format(this.items.reduce((sum, item) => sum + item.price * item.quantity, 0) / 100);
        this.add.disabled = this.busy || !this.loaded || this.uncertain || this.completed || count === 0 || invalid;
        this.add.textContent = this.busy && this.submitting ? this.dataset.adding : this.dataset.addLabel;
        this.reset.hidden = count === 0;
        this.reset.disabled = this.busy || this.uncertain || this.completed;
      }
      async addSelection() {
        if (this.busy || this.uncertain || this.completed || !this.loaded || this.total() === 0) return;
        this.busy = true;
        this.submitting = true;
        this.status.textContent = this.dataset.loading;
        this.render();
        let posted = false;
        try {
          await this.readCart();
          if (this.total() + this.existing > 6 || this.items.some(item => item.quantity > Math.max(0, item.stock - this.inCart(item)))) {
            this.status.textContent = this.dataset.over;
            return;
          }
          const items = this.items.filter(item => item.quantity > 0).map(item => ({ id: item.id, quantity: item.quantity }));
          this.status.textContent = this.dataset.adding;
          try { localStorage.setItem(this.pendingKey, JSON.stringify({ at: Date.now(), items })); } catch {}
          posted = true;
          const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }), signal: AbortSignal.timeout(20000) });
          if (!response.ok) throw new Error('add');
          this.completed = true;
          try { localStorage.removeItem(this.pendingKey); } catch {}
          window.location.assign(this.dataset.cartUrl);
        } catch {
          this.uncertain = posted;
          if (!posted) this.loaded = false;
          this.status.textContent = posted ? this.dataset.addError : this.dataset.readError;
          this.retry.hidden = posted;
        } finally {
          this.busy = false;
          this.submitting = false;
          this.render();
        }
      }
    }
    customElements.define('doma-box-builder', DomaBoxBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
